import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_administration/settings/roles")({
  beforeLoad: ({ context }) => guardRoute(context.me, "role-management"),
  component: Outlet,
});
